import img1 from "assets/img/destination/annaba.jpeg";
import img2 from "assets/img/destination/dubai.jpeg";
import img3 from "assets/img/destination/paris.jpeg";
import img4 from "assets/img/destination/lara.jpeg";
import img5 from "assets/img/destination/Istanbul.jpeg";
import img6 from "assets/img/destination/tabarka.jpeg";
import img7 from "assets/img/destination/monastir.jpeg";
import img8 from "assets/img/destination/hammamet.jpeg";
import img9 from "assets/img/destination/sousse.jpeg";

function generateCheckInDate() {
    const today = new Date();
    today.setDate(today.getDate() + 7);
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, "0");
    const day = String(today.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
}

function generateCheckOutDate() {
    const today = new Date();
    today.setDate(today.getDate() + 12); // 7 (next week) + 5 = 12 days
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, "0");
    const day = String(today.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
}

export const TopDestinationsData = [
    {
        id: 1,
        img: img1,
        heading: "Annaba",
        search_criteria: {
            checkInDate: generateCheckInDate(),
            checkOutDate: generateCheckOutDate(),
            destination: {
                description: "Annaba - Algeria",
                descriptionEn: "Annaba - Algeria",
                id: 2231,
            },
            providers: [
                {
                    id: 773,
                    code: "DOTW",
                    user_id_1: "Flynbeds",
                    user_id_2: "1481625",
                },
            ],
        },
    },
    {
        id: 2,
        img: img2,
        heading: "Dubai",
        search_criteria: {
            checkInDate: generateCheckInDate(),
            checkOutDate: generateCheckOutDate(),
            destination: {
                description: "Dubai - United Arab Emirates",
                descriptionEn: "Dubai - United Arab Emirates",
                id: 633,
            },
            providers: [
                {
                    id: 773,
                    code: "DOTW",
                    user_id_1: "Flynbeds",
                    user_id_2: "1481625",
                },
            ],
        },
    },
    {
        id: 3,
        img: img3,
        heading: "Paris",
        search_criteria: {
            checkInDate: generateCheckInDate(),
            checkOutDate: generateCheckOutDate(),
            destination: {
                description: "Paris - Île-de-France - France",
                descriptionEn: "Paris - Île-de-France - France",
                id: 1402,
            },
            providers: [
                {
                    id: 773,
                    code: "DOTW",
                    user_id_1: "Flynbeds",
                    user_id_2: "1481625",
                },
            ],
        },
    },
    {
        id: 4,
        img: img4,
        heading: "Lara",
        search_criteria: {
            checkInDate: generateCheckInDate(),
            checkOutDate: generateCheckOutDate(),
            destination: {
                description: "Lara - Serik - Mediterranean Region - Turkey",
                descriptionEn: "Lara - Serik - Mediterranean Region - Turkey",
                id: 24600,
            },
            providers: [
                {
                    id: 773,
                    code: "DOTW",
                    user_id_1: "Flynbeds",
                    user_id_2: "1481625",
                },
            ],
        },
    },
    {
        id: 5,
        img: img5,
        heading: "Istanbul",
        search_criteria: {
            checkInDate: generateCheckInDate(),
            checkOutDate: generateCheckOutDate(),
            destination: {
                description: "Istanbul - Marmara Region - Turkey",
                descriptionEn: "Istanbul - Marmara Region - Turkey",
                id: 18206,
            },
            providers: [
                {
                    id: 773,
                    code: "DOTW",
                    user_id_1: "Flynbeds",
                    user_id_2: "1481625",
                },
            ],
        },
    },
    {
        id: 6,
        img: img6,
        heading: "Tabarka",
        search_criteria: {
            checkInDate: generateCheckInDate(),
            checkOutDate: generateCheckOutDate(),
            destination: {
                description: "Tabarka - Jendouba Governorate - Tunisia",
                descriptionEn: "Tabarka - Jendouba Governorate - Tunisia",
                id: 4324,
            },
            providers: [
                {
                    id: 773,
                    code: "DOTW",
                    user_id_1: "Flynbeds",
                    user_id_2: "1481625",
                },
            ],
        },
    },
    {
        id: 7,
        img: img7,
        heading: "Monastir",
        search_criteria: {
            checkInDate: generateCheckInDate(),
            checkOutDate: generateCheckOutDate(),
            destination: {
                description: "Monastir - Monastir Governorate - Tunisia",
                descriptionEn: "Monastir - Monastir Governorate - Tunisia",
                id: 81303,
            },
            providers: [
                {
                    id: 773,
                    code: "DOTW",
                    user_id_1: "Flynbeds",
                    user_id_2: "1481625",
                },
            ],
        },
    },
    {
        id: 8,
        img: img8,
        heading: "Hammamet",
        search_criteria: {
            checkInDate: generateCheckInDate(),
            checkOutDate: generateCheckOutDate(),
            destination: {
                description: "Hammamet - Nabeul Governorate - Tunisia",
                descriptionEn: "Hammamet - Nabeul Governorate - Tunisia",
                id: 13947,
            },
            providers: [
                {
                    id: 773,
                    code: "DOTW",
                    user_id_1: "Flynbeds",
                    user_id_2: "1481625",
                },
            ],
        },
    },
    {
        id: 9,
        img: img9,
        heading: "Sousse",
        search_criteria: {
            checkInDate: generateCheckInDate(),
            checkOutDate: generateCheckOutDate(),
            destination: {
                description: "Sousse - Sousse Governorate - Tunisia",
                descriptionEn: "Sousse - Sousse Governorate - Tunisia",
                id: 1662,
            },
            providers: [
                {
                    id: 773,
                    code: "DOTW",
                    user_id_1: "Flynbeds",
                    user_id_2: "1481625",
                },
            ],
        },
    },
];
